// GENERATED FILE - DO NOT MODIFY
export enum ProjectInvoicingMode {
    MultiCust = "8",
}

export let nameof = "ProjectInvoicingMode";
